// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.create_Container {
  background-color: var(--body-bg-color);
}
.container {
  display: flex;
  flex-direction: column;
  height: 100vh;
}

.bottom-row {
  width: 100%;
  gap: 20px;
  height: 100vh;
}

.leftBox {
  width: 25%;
  height: 100vh;
  background-color: var(--white-color);
  color: var(--dark-color);
  display: flex;
  flex-direction: column;
  align-items: center;
  border-radius: 8px;
  box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
}
.rightBox {
  height: 100vh;
  color: black;
  display: flex;
  flex-direction: column;
  box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
  background-color: rgb(241, 241, 241);
  overflow-y: auto;
  width: 100%;
  padding: 20px;
}
.rightBox .right_header {
  width: 100%;
  flex: 1 1;
}
/* 
.container .accordion {
  border-bottom: 1px solid #ccc;
  margin: 0px;
  width: 100%;
}

.container .accordion-title {
  background-color: #f1f1f1;
  padding: 18px 12px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: var(--dark-color);
  font-size: 16px;
  font-weight: 500;
}
.accordion_ic {
  font-size: 24px;
  color: var(--dark-color);
}
.container .accordion-content {
  padding: 0px;
  background-color: var(--white-color);
  display: block;
  color: var(--dark2-color);
}

.container .sub-option {
  padding: 20px 10px;
  cursor: pointer;
  border-bottom: 1px solid #ddd;
}

.container .sub-option:last-child {
  border-bottom: none;
}


.sub-option {
  color: var(--dark2-color);
  cursor: pointer;
}

.sub-option.selected {
  color: #007bff; 
} */
`, "",{"version":3,"sources":["webpack://./src/Component/NewDocument/DocComp.js/ParentStyle.css"],"names":[],"mappings":"AAAA;EACE,sCAAsC;AACxC;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,SAAS;EACT,aAAa;AACf;;AAEA;EACE,UAAU;EACV,aAAa;EACb,oCAAoC;EACpC,wBAAwB;EACxB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,4CAA4C;AAC9C;AACA;EACE,aAAa;EACb,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,4CAA4C;EAC5C,oCAAoC;EACpC,gBAAgB;EAChB,WAAW;EACX,aAAa;AACf;AACA;EACE,WAAW;EACX,SAAO;AACT;AACA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;GA+CG","sourcesContent":[".create_Container {\n  background-color: var(--body-bg-color);\n}\n.container {\n  display: flex;\n  flex-direction: column;\n  height: 100vh;\n}\n\n.bottom-row {\n  width: 100%;\n  gap: 20px;\n  height: 100vh;\n}\n\n.leftBox {\n  width: 25%;\n  height: 100vh;\n  background-color: var(--white-color);\n  color: var(--dark-color);\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  border-radius: 8px;\n  box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;\n}\n.rightBox {\n  height: 100vh;\n  color: black;\n  display: flex;\n  flex-direction: column;\n  box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;\n  background-color: rgb(241, 241, 241);\n  overflow-y: auto;\n  width: 100%;\n  padding: 20px;\n}\n.rightBox .right_header {\n  width: 100%;\n  flex: 1;\n}\n/* \n.container .accordion {\n  border-bottom: 1px solid #ccc;\n  margin: 0px;\n  width: 100%;\n}\n\n.container .accordion-title {\n  background-color: #f1f1f1;\n  padding: 18px 12px;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  color: var(--dark-color);\n  font-size: 16px;\n  font-weight: 500;\n}\n.accordion_ic {\n  font-size: 24px;\n  color: var(--dark-color);\n}\n.container .accordion-content {\n  padding: 0px;\n  background-color: var(--white-color);\n  display: block;\n  color: var(--dark2-color);\n}\n\n.container .sub-option {\n  padding: 20px 10px;\n  cursor: pointer;\n  border-bottom: 1px solid #ddd;\n}\n\n.container .sub-option:last-child {\n  border-bottom: none;\n}\n\n\n.sub-option {\n  color: var(--dark2-color);\n  cursor: pointer;\n}\n\n.sub-option.selected {\n  color: #007bff; \n} */\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
